/*
 * 📖 /arcade/rules/dfcl — Standalone DFCL Rulebook page
 * ------------------------------------------------------
 * Shareable deep link to the Dragonious Flame Card Legends rules.
 * Reuses the same `DFCLRulebook` component as the Arcade overlay —
 * `standalone` mode strips the modal chrome and renders it as a
 * regular page (no backdrop click-to-close, no dim overlay).
 *
 * This URL is safe to share with players and tournament runners;
 * the Print / Save as PDF button lives inside the rulebook itself.
 */
import { useEffect } from "react";
import DFCLRulebook from "@/components/DFCLRulebook";

export default function DFCLRulesPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Dragonious Flame Card Legends — Official Rules";
    return () => { document.title = prev; };
  }, []);
  return <DFCLRulebook standalone />;
}
